export const extractItems = (payload) => {
  if (!payload) return [];

  // Direct array response
  if (Array.isArray(payload)) return payload;

  // Common envelope shapes
  if (payload && typeof payload === "object") {
    if (Array.isArray(payload.items)) return payload.items;
    if (Array.isArray(payload.data)) return payload.data;
    if (Array.isArray(payload.news)) return payload.news;
    if (Array.isArray(payload.results)) return payload.results;

    // Sometimes API wraps items inside `data.items` or similar
    if (payload.data && typeof payload.data === "object") {
      if (Array.isArray(payload.data.items)) return payload.data.items;
      if (Array.isArray(payload.data.news)) return payload.data.news;
      if (Array.isArray(payload.data.results)) return payload.data.results;
    }

    // Fallback: find the first array property and return it
    for (const key of Object.keys(payload)) {
      if (Array.isArray(payload[key])) return payload[key];
    }
  }

  return [];
};
